// @ts-nocheck
/* eslint-disable */
export const timerIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 3.1a5.787 5.787 0 0 0-5.78 5.78c0 3.187 2.593 5.787 5.78 5.787a5.787 5.787 0 0 0 5.78-5.78C13.78 5.7 11.187 3.1 8 3.1m.5 5.567c0 .273-.227.5-.5.5a.504.504 0 0 1-.5-.5V5.333c0-.273.227-.5.5-.5s.5.227.5.5zM9.927 2.3H6.073a.484.484 0 0 1 0-.967h3.854a.484.484 0 0 1 0 .967"/></svg>`,
    name: 'timer' as const
};